module.exports = __webpack_public_path__ + "img/sections-active-tab.a4029ac0.svg";